import template from './kform-builder-option-key.html';
import controller from './kform-builder-option-key.controller';

/**
 * A directive for a field to edit a component's key.
 *
 * @returns {*} Directive
 */
const kformBuilderOptionKeyDirective = /* @ngInject */ () => ({
	restrict: 'E',
	replace: true,
	template,
	controller,
});

export default kformBuilderOptionKeyDirective;
